/* eslint-disable react/jsx-no-useless-fragment */
import { FC } from "react";

import {
  TypographyH5,
  TypographyH6,
} from "@shared-ui-components/CustomTypography";

import { ErrorState } from "@src/constants";
import { Skeleton } from "@mui/material";
import { ProfileListWrapper } from "../style";
import { getMapprofileData } from "./helper";

interface ProfileListType {
  userData: ProfileResponseType;
  loading: boolean;
}

const ProfileList: FC<ProfileListType> = ({ userData, loading }) => {
  const mappedProfileData = getMapprofileData(userData);

  const getContent = (value: string | undefined, showLoader: boolean) => {
    if (showLoader) return <Skeleton width="70%" />;
    if (value === null || value === undefined) return <ErrorState />;
    return <TypographyH5 className="content">{value}</TypographyH5>;
  };

  const getTitle = (value: string, showLoader: boolean) => {
    if (showLoader) return <Skeleton width="40%" />;
    return <TypographyH6>{value}</TypographyH6>;
  };

  return (
    <>
      {mappedProfileData?.map(({ title, content }: UserDataType) => (
        <ProfileListWrapper>
          {getTitle(title, loading)}
          {getContent(content, loading)}
        </ProfileListWrapper>
      ))}
    </>
  );
};

export default ProfileList;
